import script from "./Camera.vue?vue&type=script&setup=true&lang=js"
export * from "./Camera.vue?vue&type=script&setup=true&lang=js"

import "./Camera.vue?vue&type=style&index=0&id=36da605c&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36da605c"]])

export default __exports__